import { useCheckResourcePermissions } from '@spotify/plugin-confidence-permissions-react';

export const useCanCreatePulse = (): ReturnType<
  typeof useCheckResourcePermissions
> =>
  useCheckResourcePermissions({
    name: 'account',
    can: 'create_pulse',
    optimistic: false,
  });
